// removed by extract-text-webpack-plugin
module.exports = {"inputError":"src-components-form-inputs----inputs-module---inputError---3iZ15","input":"src-components-form-inputs----inputs-module---input---27RYq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/form/inputs/inputs.module.css
// module id = 85
// module chunks = 168707334958949